module.exports = "/packs/step3-4c5c97420835cdc51404ac09809fd9d3.png";